/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.alertsModule', ['ngAnimate', 'bulbApp.ajaxModule', 'bulbApp.browserModule',
  'bulbApp.configModule', 'bulbApp.translateModule'])

/**
 * MAINTENANCE: manifest constants for maintenance alert.
 *    COOKIE_NAME: The cookie that indicates that a maintenance period is currently scheduled.
 *    ACK_PATTERN: The suffix added by this controller to the cookie value to indicate that
 *      the maintenance alert has been acknowledged.
 *
 * UNSUPPORTED_BROWSER: manifest constants for unsupported browser alert.
 *    COOKIE_NAME: The cookie that indicates that this alert has already been seen and dismissed.
 *    COOKIE_EXPIRES: If browser is currently supported, the lifetime of this cookie, in days.
 *      We will check browser validity again when the cookie expires.
 *          If browser is unsupported, cookie is a session cookie.
 *
 * COOKIE_USAGE: Setting cookie expiration time to 10 years.  
 *        
 */

.constant('ALERT', {
  MAINTENANCE: {
    COOKIE_NAME: 'bulb-maintenanceBegins',
    ACK_PATTERN: ':ACK'
  },
  UNSUPPORTED_BROWSER: {
    COOKIE_NAME: 'bulb-hasSeenBrowserWarning',
    COOKIE_EXPIRES: 365
  },
  COOKIE_USAGE: {
    COOKIE_NAME: 'bulb-acceptCookies',
    COOKIE_EXPIRES: 3650
  }
})

// Add the constants to the root scope:
.run(['$rootScope', 'ALERT', function($rootScope, ALERT) {
  $rootScope.ALERT = ALERT;
}]);
